export class SearchCondition{
    public empCd: string
    public workingYm: string
    public beforeViewName: string
    public beforeViewParam1: string
    public beforeViewParam2: string
    public beforeViewParam3: string
}
